import workspaceQuery from 'graphql/queries/common/JobTitleWorkspaceQuery.graphql';
import instanceQuery from 'graphql/queries/common/JobTitleQuery.graphql';
import fragment from 'graphql/fragments/common/JobTitleFragment.graphql';
import defaultQuery from 'graphql/queries/common/JobTitleDefault.graphql';
import mutationQuery from 'graphql/mutations/common/JobTitleMutation.graphql';
import listQuery from 'graphql/queries/common/JobTitleListQuery.graphql';
import { EntityType } from '../../../@types/entityTypes';

const JobTitle: EntityType = {
  type: 'JobTitle',
  title: 'Job Title',
  formTitle: 'Job Title',
  formUrl: '/Common/JobTitle/Details/',
  workspaceUrl: '/Common/JobTitle/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'description',
    remoteFilter: true,
    preLoad: true,
  },
  fragment,
  screenReference: 'JOB_TITLE',
};

export default JobTitle;
